import { selectRawFilterData } from './general';

function selectActiveSortType(state, filterId) {
    return selectRawFilterData(state, filterId).sortType;
}

export {
    selectActiveSortType,
};
